module.exports = __webpack_public_path__ + "img/checkApp4.5a863dfd.png";